import DOMPurify from "isomorphic-dompurify";

const ALLOWED_TAGS = [
  "p", "br", "strong", "em", "u", "ul", "ol", "li", "a",
  "h2", "h3", "h4", "hr", "blockquote", "span", "div",
  "table", "thead", "tbody", "tfoot", "tr", "th", "td", "caption", "colgroup", "col",
  "figure", "figcaption",
  "svg", "g", "path", "rect", "line", "circle", "ellipse", "polyline", "polygon", "text", "tspan", "title", "desc", "defs", "linearGradient", "radialGradient", "stop", "use", "clipPath", "mask",
];
const ALLOWED_ATTR = [
  "href", "target", "rel", "id", "class", "style", "title",
  "data-label",
  "colspan", "rowspan", "scope",
  "xmlns", "viewBox", "width", "height", "fill", "stroke", "stroke-width", "stroke-linecap", "stroke-linejoin",
  "x", "y", "x1", "y1", "x2", "y2", "cx", "cy", "r", "rx", "ry",
  "d", "points", "transform", "opacity", "fill-opacity", "stroke-opacity",
  "text-anchor", "dominant-baseline", "font-size", "font-family", "font-weight",
  "role", "aria-label", "aria-labelledby", "aria-describedby",
  "offset", "stop-color", "stop-opacity", "gradientUnits", "gradientTransform",
];

export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|#|\/)/i,
  });
}
